import { getChatVersion } from './getChatVersion.js'

/**
 * Extracts chat parameters from URL query parameters
 * @returns {Record<string, any>} Chat parameters object
 */
export function getChatParamsFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  // Start with default params like your original code
  let params = Object.fromEntries(
    new URLSearchParams('NOTE%3DNOT%20IN%20VS').entries(),
  )

  if (urlParams.get('l')) {
    try {
      const url = atob(urlParams.get('l') || '')
      const paramsMatch = url.match(/params=([^&]*)/)

      const paramString = paramsMatch ? paramsMatch[1] : 'NOTE%3DNOT%20IN%20VS'
      params = Object.fromEntries(
        new URLSearchParams(decodeURIComponent(paramString)).entries(),
      )

      // Add chatVersion to params with brand
      const brandName = urlParams.get('brandName')
      params.chatVersion = getChatVersion(brandName || 'Unlabeled')
    } catch (error) {
      console.warn('Error decoding base64 URL parameter:', error)
    }
  }

  // Handle direct params parameter
  if (urlParams.get('params')) {
    params = Object.fromEntries(
      new URLSearchParams(
        `Add%20to%20VS%20manually%3D(fields%20below)&${new URLSearchParams(
          urlParams.get('params') || '',
        ).toString()}`,
      ).entries(),
    )
  }

  // Handle VanillaSoft ID
  if (urlParams.get('vs_id') && urlParams.get('g')) {
    params = Object.fromEntries(
      new URLSearchParams(
        `VanillaSoft_ID%3D${urlParams.get('vs_id')}`,
      ).entries(),
    )
  }

  // Handle general group parameter with sub parameters (adds to existing params)
  if (urlParams.get('g') && !urlParams.get('vs_id') && !urlParams.get('e')) {
    const sub1 = urlParams.get('sub1')
    const sub2 = urlParams.get('sub2')

    if (sub1 || sub2) {
      if (sub1) {
        params.sub1 = sub1
      }
      if (sub2) {
        params.sub2 = sub2
      }
    }
  }

  // Add source URL to track where users are coming from
  params.stack = 'funnels'

  return params
}
